// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3NlRW","header":"MergedInvoice_header__1cHtm"};